import { useLocale } from '@/i18n/locale-context';
import type { Locale } from '@/i18n/types';
import { cn } from '@/lib/utils';

const options: { value: Locale; labelKey: 'zh' | 'en' }[] = [
  { value: 'zh-CN', labelKey: 'zh' },
  { value: 'en', labelKey: 'en' },
];

export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale, t } = useLocale();

  return (
    <div
      role="group"
      aria-label={t.language.switchLabel}
      className={cn(
        'inline-flex items-center rounded-full bg-muted/70 p-0.5 text-[12px] font-medium',
        className
      )}
    >
      {options.map(({ value, labelKey }) => {
        const active = locale === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setLocale(value)}
            aria-pressed={active}
            className={cn(
              'rounded-full px-2.5 py-1 transition-colors',
              active
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {t.language[labelKey]}
          </button>
        );
      })}
    </div>
  );
}
